const escapeIcs = (value) => {
  return String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\r?\n/g, '\\n')
}

const stripHtmlInline = (html) => {
  if (!html) return ''
  const tmp = document.createElement('div')
  tmp.innerHTML = String(html)
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim()
}

const stripHtmlMultiline = (html) => {
  if (!html) return ''
  const withBreaks = String(html)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li)>/gi, '\n')
    .replace(/<\/(h[1-6])>/gi, '\n\n')
  const tmp = document.createElement('div')
  tmp.innerHTML = withBreaks
  return (tmp.textContent || tmp.innerText || '')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/^\s+|\s+$/g, '')
}

const addOneDay = (yyyymmdd) => {
  if (!yyyymmdd || yyyymmdd.length !== 8) return yyyymmdd
  const y = parseInt(yyyymmdd.substring(0, 4), 10)
  const m = parseInt(yyyymmdd.substring(4, 6), 10)
  const d = parseInt(yyyymmdd.substring(6, 8), 10)
  const date = new Date(Date.UTC(y, m - 1, d + 1))
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}`
}

const formatStamp = (date) => {
  return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')
}

const foldIcsLine = (line) => {
  if (line.length <= 75) return line
  const parts = [line.substring(0, 75)]
  let remaining = line.substring(75)
  while (remaining.length > 74) {
    parts.push(' ' + remaining.substring(0, 74))
    remaining = remaining.substring(74)
  }
  if (remaining.length > 0) parts.push(' ' + remaining)
  return parts.join('\r\n')
}

const buildGoogleUrl = ({ title, start, end, location, details }) => {
  const exclusiveEnd = addOneDay(end || start)
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title || '',
    dates: `${start}/${exclusiveEnd}`,
    location: location || '',
    details: details || ''
  })
  return `https://calendar.google.com/calendar/render?${params.toString()}`
}

const buildIcs = ({ title, start, end, location, details }) => {
  const exclusiveEnd = addOneDay(end || start)
  const uid = `${Date.now()}-${Math.random().toString(36).slice(2)}@hermetic-pumpen.com`
  const stamp = formatStamp(new Date())
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Hermetic//Exhibition//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${stamp}`,
    `CREATED:${stamp}`,
    `LAST-MODIFIED:${stamp}`,
    `DTSTART;VALUE=DATE:${start}`,
    `DTEND;VALUE=DATE:${exclusiveEnd}`,
    `SUMMARY:${escapeIcs(title)}`,
    `LOCATION:${escapeIcs(location)}`,
    `DESCRIPTION:${escapeIcs(details)}`,
    'STATUS:CONFIRMED',
    'SEQUENCE:0',
    'CLASS:PUBLIC',
    'TRANSP:OPAQUE',
    'X-MICROSOFT-CDO-ALLDAYEVENT:TRUE',
    'X-MICROSOFT-CDO-BUSYSTATUS:FREE',
    'X-MICROSOFT-CDO-IMPORTANCE:1',
    'X-MS-OLK-AUTOFILLLOCATION:FALSE',
    'X-MICROSOFT-DISALLOW-COUNTER:FALSE',
    'END:VEVENT',
    'END:VCALENDAR'
  ]
  return lines.map(foldIcsLine).join('\r\n') + '\r\n'
}

const downloadIcs = (event) => {
  const content = '﻿' + buildIcs(event)
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const filename = (event.title || 'event').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') + '.ics'

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 100)
}

const openGoogle = (event) => {
  window.open(buildGoogleUrl(event), '_blank', 'noopener')
}

const readEvent = (button) => ({
  title: stripHtmlInline(button.dataset.title),
  start: button.dataset.start || '',
  end: button.dataset.end || button.dataset.start || '',
  location: stripHtmlInline(button.dataset.location),
  details: stripHtmlMultiline(button.dataset.details)
})

const initCalendarButtons = () => {
  document.querySelectorAll('[data-calendar]').forEach((button) => {
    if (button.dataset.calendarInit) return
    button.dataset.calendarInit = '1'

    button.addEventListener('click', (event) => {
      event.preventDefault()
      const data = readEvent(button)
      if (!data.start) return

      if (button.dataset.calendar === 'google') {
        openGoogle(data)
      } else if (button.dataset.calendar === 'ics') {
        downloadIcs(data)
      }
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCalendarButtons)
} else {
  initCalendarButtons()
}
